import { render, staticRenderFns } from "./settingsDepartmentIcon.vue?vue&type=template&id=5e06000b&scoped=true"
import script from "./settingsDepartmentIcon.vue?vue&type=script&lang=js"
export * from "./settingsDepartmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06000b",
  null
  
)

export default component.exports